import React, { useEffect, useState } from 'react';
import { SEO } from '../components/SEO';
import { CTASection } from '../components/CTASection';
import { galleryImages, beforeAfterGallery } from '../data/mock';
import { X } from 'lucide-react';

export const Galeria = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (selectedImage) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [selectedImage]);

  return (
    <>
      <SEO 
        title="Galeria Box7go - Fotos Antes e Depois | Lava Jato e Estética Automotiva Goiânia"
        description="Confira fotos dos serviços realizados na Box7go: lavagens, detalhamentos e estética automotiva em Goiânia. Resultados antes e depois que impressionam!"
        keywords="galeria box7go, fotos lava jato goiania, antes e depois estética automotiva, trabalhos box7go, detalhamento goiania"
      />

      {/* Hero */}
      <section className="bg-gradient-to-br from-black via-gray-900 to-[#00B4D8] py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Nossa Galeria
          </h1>
          <p className="text-xl text-white/90 max-w-2xl mx-auto">
            Confira a qualidade dos nossos serviços através de resultados reais
          </p>
        </div>
      </section>

      {/* Antes e Depois */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Antes e Depois
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              A transformação que fazemos em cada veículo
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {beforeAfterGallery.map((item, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-shadow">
                <div className="grid grid-cols-2">
                  <div className="relative">
                    <img 
                      src={item.before} 
                      alt={`${item.title} - Antes`}
                      className="w-full h-48 object-cover cursor-pointer hover:opacity-90 transition-opacity"
                      onClick={() => setSelectedImage(item.before)}
                    />
                    <div className="absolute bottom-2 left-2 bg-red-500 text-white text-xs font-bold px-3 py-1 rounded">
                      ANTES
                    </div>
                  </div>
                  <div className="relative">
                    <img 
                      src={item.after} 
                      alt={`${item.title} - Depois`}
                      className="w-full h-48 object-cover cursor-pointer hover:opacity-90 transition-opacity"
                      onClick={() => setSelectedImage(item.after)}
                    />
                    <div className="absolute bottom-2 right-2 bg-green-500 text-white text-xs font-bold px-3 py-1 rounded">
                      DEPOIS
                    </div>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="font-bold text-gray-900 text-center">{item.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Galeria Principal */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Nossos Trabalhos
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Detalhamento e acabamento de alta qualidade
            </p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {galleryImages.map((image, index) => (
              <div 
                key={index} 
                className="relative overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-all duration-300 aspect-square cursor-pointer group"
                onClick={() => setSelectedImage(image)}
              >
                <img 
                  src={image} 
                  alt={`Trabalho Box7go ${index + 1}`}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300"></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div 
          className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <button
            onClick={() => setSelectedImage(null)}
            className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors"
            aria-label="Fechar"
          >
            <X className="w-8 h-8" />
          </button>
          <img 
            src={selectedImage} 
            alt="Imagem ampliada"
            className="max-w-full max-h-full object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}

      {/* CTA */}
      <CTASection 
        title="Gostou do que viu?"
        subtitle="Seu veículo pode ter o mesmo resultado. Agende agora!"
      />
    </>
  );
};
